<template>
    <b-row
        align-h="between"
        tag="nav"
    >
        <b-col
            cols="10"
            sm="auto"
        >
            <b-link :to="{name: `home${routePrefix}`}">
                <img
                    v-if="!$route.meta.theme"
                    src="~@/assets/images/logo.png"
                    class="img-fluid logo"
                    alt="Logo"
                >

                <img
                    v-else
                    :src="require(`@/assets/images/logo-cancer${whiteLogo ? '-white' : ''}.svg`)"
                    class="img-fluid logo"
                    alt="Logo"
                >
            </b-link>
        </b-col>

        <b-col
            v-if="!noMenu"
            cols="auto"
            class="d-none d-lg-block"
        >
            <b-btn
                class="mr-3"
                variant="primary"
                :to="{name: `test${routePrefix}`}"
            >
                {{ $t('common.buttons.linkTest') }}
            </b-btn>

            <b-btn
                variant="link"
                class="text-white"
                :to="{
                    name: `home${routePrefix}`,
                    query: { story: 1 },
                }"
            >
                {{ $t('common.buttons.linkStories') }}
            </b-btn>
        </b-col>
    </b-row>
</template>

<script>
export default {
    name: 'Navbar',
    props: {
        noMenu: {
            type: Boolean,
            default: false,
        },
        whiteLogo: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            routePrefix: undefined,
        };
    },
    watch: {
        $route: {
            handler: function() {
                this.routePrefix = this.$route.name.endsWith('Cancer') ? 'Cancer' : '';
            },
            immediate: true,
        },
    },
};
</script>
